// Function for the Embedded Posts Icon
function EPIcon() {
    return (
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" aria-hidden="true" focusable="false">
                <g>
                    <path d="M17.3,9.2c-0.1-0.1-0.3-0.1-0.4-0.1h-1.5v2.4H17c0.1,0,0.2,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.4c0.1-0.2,0.1-0.4,0.1-0.7
                        c0-0.3,0-0.6-0.1-0.7C17.6,9.4,17.5,9.3,17.3,9.2z"/>
                    <path d="M12,0C5.4,0,0,5.4,0,12c0,6.6,5.4,12,12,12s12-5.4,12-12C24,5.4,18.6,0,12,0z M11,17.5H3.1v-11h7.7v2.6H6.2v1.6h4v2.5h-4
                        v1.7H11V17.5z M20.4,12.2c-0.3,0.6-0.7,1.1-1.3,1.4c-0.5,0.4-1.2,0.6-1.9,0.6h-1.8v3.4h-3v-11h4.7c0.5,0,1,0.1,1.5,0.3
                        c0.5,0.2,0.8,0.5,1.2,0.9c0.3,0.4,0.6,0.8,0.8,1.2c0.2,0.5,0.3,0.9,0.3,1.4C20.9,11,20.7,11.6,20.4,12.2z"/>
                </g>
            </svg>
    );
}

// Export the Embedded Posts Icon component
export default EPIcon;
